// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__oeN6v","title":"ClientReferral_title__3oeZT","itemText":"ClientReferral_itemText__1HJj4"};